module.exports = __webpack_public_path__ + "static/media/Alto-Falante.c00b5b63.png";